var React = require("react"),
  ReactDOM = require("react-dom");

// require("../styles/importer.less");

var Alert = require("react-bootstrap").Alert;
var cookie = require("react-cookies");

/*************************************************************
SIGN UP
*************************************************************/

var Content = React.createClass({
  getInitialState: function() {
    var isCookieAlertDisplayed2 =
      typeof isCookieAlertDisplayed != "undefined" && isCookieAlertDisplayed ? true : false;
    var isAlertCookieAlreadyDisplayed = cookie.load("isAlertCookieAlreadyDisplayed") ? true : false;

    var alertVisible;
    if (!isCookieAlertDisplayed2) {
      alertVisible = false;
    } else {
      alertVisible = !isAlertCookieAlreadyDisplayed;
    }

    return {
      alertVisible: alertVisible
    };
  },

  componentDidMount: function() {
    this.saveCookie_isAlertCookieAlreadyDisplayed();
  },

  render: function() {
    if (this.state.alertVisible) {
      return (
        <Alert
          bsClass="alert-fixed alert alert-info"
          bsStyle="danger"
          onDismiss={this.handleAlertDismiss}
        >
          En poursuivant votre navigation sur ce site, vous acceptez nos CGV et l’utilisation de
          cookies pour vous proposer des contenus et services adaptés à vos centres d’intérêts et
          vous permettre l'utilisation de boutons de partages sociaux.
        </Alert>
      );
    } else {
      return <div />;
    }
  },

  handleAlertDismiss: function() {
    this.setState({ alertVisible: false });
    this.saveCookie_isAlertCookieAlreadyDisplayed();
  },

  saveCookie_isAlertCookieAlreadyDisplayed: function() {
    cookie.save("isAlertCookieAlreadyDisplayed", true, {
      maxAge: 60 * 60 * 24 * 365
    });
  }
});

ReactDOM.render(<Content />, document.getElementById("containerCookies"));



// WEBPACK FOOTER //
// ./assets/react/cookies.jsx